const localState = {
    notifications: [],
    rawNotifications: [],
    updateCount: false,
    masterWasLate: false,
    showNotification: true,
    isShowNotification: false,
}

const actions = {
    async getNotification({
        state,
        commit,
    }) {
        try {
            const response = await this.$api.notifications.fetch()
            state.rawNotifications = response.data.notifications
            commit('SET_NOTIFICATIONS', response.data.notifications)
            return state.data
        } catch (err) {
            console.log(err)
        }
    },
    async readNotification({
        state,
        dispatch,
    }, notifications) {
        try {
            await this.$api.notifications.read({
                notifications,
            })
            await dispatch('getNotification')
            return state.data
        } catch (err) {
            console.log(err)
        }
    },
    addNotification({
        state,
        commit,
        rootState,
    }, data) {
        if (rootState.chat.currentDialog !== data.dialog_id) {
            state.rawNotifications.unshift(data)
            commit('SET_NOTIFICATIONS', state.rawNotifications)
        }
    },
}

const mutations = {
    toggleUpdateCount: (state) => {
        state.updateCount = !state.updateCount
    },
    SET_NOTIFICATIONS(state, data) {
        state.notifications = [...data]
            .map((item) => ({
                name: item.name,
                type: item.type,
                items: [item],
            }))
    },
    ADD_NOTIFICATION(state, {
        type,
        data,
    }) {
        data.type = type
        state.rawNotifications.push(data)
    },
    setMasterWasLate: (state, v) => {
        state.masterWasLate = v
    },
    setShowNotification: (state, v) => {
        state.showNotification = v
    },
    showNotification: (state) => {
        state.isShowNotification = !state.isShowNotification
    },
    hideNotification: (state) => {
        state.isShowNotification = false
    },

}
const getters = {
    updateCountGetters: (state) => state.updateCount,
    notificationsGetters: (state) => state.notifications,
    masterWasLateGetters: (state) => state.masterWasLate,
    showNotificationGetters: (state) => state.showNotification,
    isShowNotification: (state) => state.isShowNotification,
}

export default {
    state: localState,
    getters,
    actions,
    mutations,
}
